<template>
  <div class="openingbank search">
    <header>
      <!--<img src="../../assets/images/search.png">-->
      <!--<input type="text" placeholder="搜索“可丽金洗护套盒”" v-focus="isShow">-->
      <form action="/">
        <van-search
          v-model="keyword"
          placeholder="搜索"
          show-action
          clearable
          maxlength="32"
          @search="search"
          @cancel="cancel"
        />
      </form>
      <!--<span @click="cancel">取消</span>-->
    </header>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"
              :type="'infinite'"
      >
      <ul class="letter">
        <li v-for="item of newlist" :ref="item.letter">
          <p>{{item.letter}}</p>
          <ul class="name">
            <li v-for="itemChild of item.child" @click="choosebank(itemChild)">
              {{itemChild.name}}
            </li>
          </ul>
        </li>
      </ul>
    </Scroller>
    <ul class="nav">
      <li v-for="item of nav" @click="goItem(item)">{{item}}</li>
    </ul>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'

export default {
  name: 'openingbank',
  data () {
    return {
      list: [],
      nav: [],
      newlist: [],
      keyword: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: ''
    }
  },
  components: {
    Scroller
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next()
    } else {
      next(vm => {
        if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, false)
          }, 0) // 同步转异步操作
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'openingbank'})
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/StoreChange/bankList?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      this.$customRequestAjax(url).then(res => {
        if (this.nowPage === 1) {
          this.list = res.data.list
          this.refresh = false
        } else {
          this.list = this.list.concat(res.data.list)
        }
        this.loading = false
        let newI = -1
        this.nav = []
        this.newlist = []
        for (let i in this.list) {
          if ((i > 0 && this.list[i - 1].letter != this.list[i].letter) || i == 0) {
            this.nav.push(this.list[i].letter)
            newI++
            this.newlist.push({
              letter: this.list[i].letter,
              child: [
                {
                  id: this.list[i].id,
                  name: this.list[i].name
                }
              ]
            })
          } else if (i > 0 && this.list[i - 1].letter == this.list[i].letter) {
            this.newlist[newI].child.push({
              id: this.list[i].id,
              name: this.list[i].name
            })
          }
        }
        if (res.data.list.length < this.pagesize) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    },
    search: function () {
      if (this.keyword !== '') {
        this.refresh = true
        this.nowPage = 1
        this.newlist = []
        this.onRefresh()
      }
    },
    choosebank: function (item) {
      sessionStorage.setItem('bank_name_choose_item', JSON.stringify(item))
      this.$router.go(-1)
    },
    cancel: function () {
      this.$router.go(-1)
    },
    goItem: function (item) {
      console.log(this.$refs)
      scrollTo(0, this.$refs[item][0].offsetTop)
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
  .openingbank {
    background: #F5F5F5;
    header {
      padding-left: 0.1rem;
      background: #fff;
    }
    .letter {
      >li {
        p {
          padding: 0 0.11rem;
          background: #F5F5F5;
          color: #B7B7B7;
          font-size: 0.12rem;
          line-height: 0.35rem;
        }
        .name {
          background: #fff;
          li {
            color: #333;
            font-size: 0.12rem;
            line-height: 0.45rem;
            border-bottom: 0.005rem solid #D8D8D8;
            padding: 0 0.21rem;
            &:last-of-type {
              border-bottom-width: 0;
            }
          }
        }
      }
    }
    .nav {
      position: fixed;
      right: 0.07rem;
      top: 50%;
      transform: translateY(-50%);
      background: rgb(253, 234, 234);
      border-radius: 0.12rem;
      padding: 0.05rem 0;
      li {
        color: #333;
        font-size: 0.12rem;
        padding: 0.02rem 0.05rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/storechange/openingbank.vue